import { render, staticRenderFns } from "./TanUpdateOld.vue?vue&type=template&id=25f7d36a&scoped=true&"
import script from "./TanUpdateOld.vue?vue&type=script&lang=js&"
export * from "./TanUpdateOld.vue?vue&type=script&lang=js&"
import style0 from "./TanUpdateOld.vue?vue&type=style&index=0&id=25f7d36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f7d36a",
  null
  
)

export default component.exports